export const SHORT = '200ms';
export const MEDIUM = '500ms';